import {BindingDriftReport} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty
} from "@flexinet/ui-components";
import {Anchor, Stack, Text, Title} from "@mantine/core";
import {RunHealthBadge} from "./Badges.tsx";
import {FindingsTable} from "./FindingsTable.tsx";
import {parseFindings} from "../utils/parseFindings.ts";

export const Profile = ({record}: { record: BindingDriftReport }) => {

    const summaryProperties = [
        {
            label: 'ID',
            value: record.id as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        },
        {
            label: 'Status',
            value: <RunHealthBadge record={record}/>,
            span: 12,
        },
        {
            label: 'Run Date',
            value: (record.runDate as string) ?? '—',
            span: 6,
        },
        {
            label: 'Accounts Scanned',
            value: typeof record.accountsScanned === 'number' ? String(record.accountsScanned) : '—',
            span: 6,
        },
        {
            label: 'Run Started At',
            value: record.runStartedAt as string,
            formatAs: 'Timestamp',
            span: 6,
        },
        {
            label: 'Run Completed At',
            value: (record.runCompletedAt as string) ?? '—',
            formatAs: 'Timestamp',
            span: 6,
        },
    ] as PlatformPropertyCardProperty[];

    const outcomeProperties = [
        {
            label: 'Drift Detected',
            value: typeof record.driftDetectedCount === 'number' ? String(record.driftDetectedCount) : '0',
            span: 6,
        },
        {
            label: 'Repaired',
            value: typeof record.repairedCount === 'number' ? String(record.repairedCount) : '0',
            span: 6,
        },
        {
            label: 'Repair Failed',
            value: typeof record.repairFailedCount === 'number' ? String(record.repairFailedCount) : '0',
            span: 6,
        },
        {
            label: 'Repair Capped',
            value: typeof record.repairCappedCount === 'number' ? String(record.repairCappedCount) : '0',
            span: 6,
        },
    ] as PlatformPropertyCardProperty[];

    const findings = parseFindings(record.findings);

    return (
        <Stack gap={'lg'}>
            <PlatformPropertyCard properties={summaryProperties}/>
            <PlatformPropertyCard properties={outcomeProperties}/>

            <Stack gap={'xs'}>
                <Title order={5}>Per-account findings</Title>
                {findings.length > 0
                    ? <FindingsTable findings={findings}/>
                    : <Text c={'dimmed'} size={'sm'}>No per-account findings for this run.</Text>}
                {record.findingsS3Uri
                    ? <Text size={'xs'} c={'dimmed'}>
                        Full findings overflowed inline storage:&nbsp;
                        <Anchor href={record.findingsS3Uri as string} size={'xs'}>{record.findingsS3Uri as string}</Anchor>
                    </Text>
                    : null}
            </Stack>
        </Stack>
    );
};
